import type { RaceResult } from '../domain/race.ts';
import type { RaceState } from '../domain/types.ts';

/** Final classification includes the photo finish, which follows the last turn. */
export function raceViewAt(result: RaceResult, start: RaceState, cursor: number) {
  const played = result.turns.slice(0, Math.max(0, cursor));
  const turn = played.at(-1) ?? null;
  const previous = played.length > 1 ? played[played.length - 2].state : turn ? start : null;
  const state = turn && cursor >= result.turnsRun ? result.state : turn?.state ?? start;
  return { state, previous, turn };
}
